import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api";
import { axiosErrorHandler } from "src/util";

const MAX_BRANDS_COUNT = 100;

export const getBrandsFetcher = reatomAsync(async (ctx) => {
  return API.brandsApi
    .brandControllerGetBrands(
      {
        limit: MAX_BRANDS_COUNT,
      },
      { signal: ctx.controller.signal },
    )
    .then((res) =>
      res.data.data.sort((a, b) => ("" + a.name).localeCompare(b.name)),
    )
    .catch(axiosErrorHandler);
}, "fetchBrands").pipe(withDataAtom(null), withAbort());
